import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<{
  isMainPage?: boolean;
  isDetailPopover?: boolean;
}> = ({ isMainPage, isDetailPopover }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: (p) => {
    if (isDetailPopover) {
      return p.spacing(0);
    }
    return p.spacing(1.5);
  },
  gap: (p) => p.spacing(1),
});

export const titleRow: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};
